package org.teddapp.project.portfolio.export

/**
 * Modèle intermédiaire des exports : le recueil et le portfolio se décrivent en blocs
 * simples, que le rendu Markdown (commun) et le rendu PDF (par plateforme) savent
 * tous deux dessiner. Seul le constructeur connaît les tables ; les rendus ne
 * connaissent que ces blocs.
 */
sealed interface DocBlock {
    /** Titre de section ; 1 = plus grand. Le titre du document est au-dessus. */
    data class Heading(val level: Int, val text: String) : DocBlock
    data class Paragraph(val text: String) : DocBlock
    /** Markdown libre écrit par l'utilisateur : recopié tel quel en .md, dégradé en PDF. */
    data class Markdown(val text: String) : DocBlock
    data class Bullets(val items: List<String>) : DocBlock
    data class KeyValues(val pairs: List<Pair<String, String>>) : DocBlock
    /** Étiquettes courtes ; tone = niveau 0..3 pour colorer, null pour neutre. */
    data class Tags(val items: List<String>, val tone: Int? = null) : DocBlock
    /** Répartition des critères par niveau (index = niveau) et niveau agrégé. */
    data class LevelBar(val distribution: IntArray, val aggregate: Int?) : DocBlock
    /** Liens externes (libellé, url). */
    data class Links(val items: List<Pair<String, String>>) : DocBlock
    /** Images par URL (url, légende). */
    data class Images(val items: List<Pair<String, String>>) : DocBlock
    data object Divider : DocBlock
    data object PageBreak : DocBlock
}

data class PortfolioDoc(
    val title: String,
    val subtitle: String?,
    val generatedAt: String,
    val blocks: List<DocBlock>,
)

/** Libellés des niveaux, partagés par les rendus (sans dépendre de l'interface). */
val LEVEL_LABELS: List<String> = listOf("Non acquis", "Notions", "Autonome", "Maîtrise")

/** Couleurs des niveaux en hexadécimal, pour les rendus qui n'ont pas les tokens Compose. */
val LEVEL_HEX: List<String> = listOf("#8A8F98", "#B87333", "#8C9BA8", "#C9A227")
